import { Router } from '@angular/router';
import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-logged-validator',
  templateUrl: './logged-validator.component.html',
  styleUrls: ['./logged-validator.component.scss']
})
export class LoggedValidatorComponent implements OnInit, OnChanges {
  @Input()
  isLoggedIn: any;

  @Output()
  confirmed = new EventEmitter<boolean>();

  constructor(
    private router: Router
  ) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    this.alert();
  }

  private alert() {
    if ((!!this.isLoggedIn)){
      Swal.fire({
        html: '<img class="msg-icon" src="/assets/images/message-icon/exclamation.png">' +
              '<div class="text-center m-t-20">' +
                '<ul><li>' + this.isLoggedIn + '</li></ul>' +
              '</div>',
          confirmButtonText: 'OK',
          reverseButtons: true,
        }).then(result => {
          this.router.navigate(['/login']);
        });
    }
  }
}
